/**
 * 文档信息，主要用于系统中各个地方的文档信息展示，包括同意某个条款、一些功能情况说明等
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import DocumentEdit from './DocumentEdit';
import { global_data } from '../../ui/auth'

class AgreementIndex extends React.Component {
    columns = [{
        title: '文档名',
        dataIndex: 'name',
        width: '20%',
    }, {
        title: '编码',
        dataIndex: 'code',
        width: '10%',
    }, {
        title: '最后修改时间',
        dataIndex: 'updateTime',
        width: '15%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '10%',
        format: { 0: '正常', 1: '删除', 2: '停用' }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("SYS_DOCUMENT_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_DOCUMENT_ENABLE")?
                <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_DOCUMENT_DISABLE")?
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, text)} />
                </Tooltip>
                :""}
            </div>
        ),
    }];

    state = {
        visible: false,
        editData: {},  //编辑的数据
        loadData: '',
        queryData: {}, //查询数据
    };

    add = () => {
        this.setState({ visible: true, editData: {} });
    }

    update = (id, e) => {
        http.get({
            url: '/document/get/' + id,
            success: (res) => {
                this.setState({ visible: true, editData: res});
            }
        });
        
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }

    disable = (info, e) => {
        messager.confirm("是否停用该文档？", () => {
            http.post({
                url: '/document/disable/' + info,
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("停用成功！");
                }
            });
        });
    }

    enable = (info, e) => {
        messager.confirm("是否启用该文档？", () => {
            http.post({
                url: '/document/enable/' + info,
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("启用成功！");
                }
            });
        });
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="文档名称"
                                    onSearch={this.inputSearch.bind(this, "name")}
                                    enterButton
                                    style={{ width: '200px', marginRight: '10px' }}
                                />
                                <Input.Search
                                    placeholder="文档编码"
                                    onSearch={this.inputSearch.bind(this, "code")}
                                    enterButton
                                    style={{ width: '200px' }}
                                />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("SYS_DOCUMENT_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    requestType="get"
                    rowKey="id"
                    url="/document/findDocumentPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <DocumentEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }

}

export default AgreementIndex;